
import { Suspense } from "react";
import { Route, Routes } from "react-router-dom";
import { VideoCall } from "./components";
import HomePage from "./components/HomePage";
import { APP_CONFIG } from "./lib/config/consultation.config";

const RoutesList = (
  <Routes>
    <Route
      path="/"
      element={<HomePage />}
    />
    <Route
      path="/:consultationId"
      element={
        <Suspense fallback={<div className="text-center mt-20">Loading video call...</div>}>
          <VideoCall appConfig={APP_CONFIG} />
        </Suspense>
      }
    />
  </Routes>
);

export default RoutesList;
